import { ReactNode } from "react";
import cx from "classnames";

import Box, { BoxProps } from "ds/components/Box";
import Typography from "ds/components/Typography";
import TextEllipsis from "ds/components/TextEllipsis";

import styles from "./styles.module.css";

type KeyValueProps = {
  name: string;
  children: ReactNode | string;
  align?: BoxProps["align"];
};

const KeyValue = ({ name, children, align }: KeyValueProps) => {
  if (!children) {
    return null;
  }

  return (
    <Box className={styles.container} justify="between" gap="large" align={align}>
      <Box shrink="0" className={styles.keyContainer}>
        <TextEllipsis tooltip={name} tooltipWidthMode="maxWidthSm">
          {(props) => (
            <Typography {...props} tag="p" variant="p-t7">
              {name}
            </Typography>
          )}
        </TextEllipsis>
      </Box>
      {typeof children === "string" ? (
        <Box>
          <Typography align="right" tag="p" variant="p-body3" className={cx(styles.value)}>
            {children}
          </Typography>
        </Box>
      ) : (
        children
      )}
    </Box>
  );
};

export default KeyValue;
